import React from 'react';
import GITextIntl from '../app-components/GIText/GITextIntl';

export interface IScrollableReadOnlyTextProps {
  id: string;
  messageIds: string[]; // Array of message IDs to render
  width?: string; // Optional width of the container
  height?: string; // Optional height of the container
  textReplacements?: { [key: string]: { [key: string]: any } }; // Dynamic values for message formatting per messageId
}

const ScrollableReadOnlyText: React.FC<IScrollableReadOnlyTextProps> = ({
    id,
    messageIds,
    width = '100%',
    height = 'auto',
    textReplacements = {},
}) => {

    return (
        <div id={id} className='read-only-wrapper' data-automation-id={id} style={{ width, height }}>
            <div className="read-only-container">
                {messageIds.map((messageId, index) => (
                    <p key={index} className="read-only-content">
                        <GITextIntl
                            id={`content-${index}`}
                            messageId={messageId}
                            shouldParse={true}
                            textReplacements={textReplacements?.[messageId]}
                        />
                    </p>
                ))}
            </div>
        </div>
    );
};

export default ScrollableReadOnlyText;